export const ASSESSMENT_PLAN_TABLE_COLUMNS = [
    {
      name: 'S.No.',
      dataKey: 'sno',
      position: 'left',
      isSortable: true,
      type: '',
    },
    {
      name: 'Module',
      dataKey: 'module',
      position: 'left',
      type: 'text',
      isSortable: true,
    },
    {
      name: 'Action',
      dataKey: 'action',
      position: 'left',
      type: 'text',
      isSortable: true,
    },
    {
      name: 'Changed by',
      dataKey: 'changedBy',
      position: 'left',
      type: 'text',
      isSortable: true,
    },
    {
      name: 'Previous State',
      dataKey: 'previousState',
      position: 'left',
      type: 'text',
      isSortable: true,
      alwaysShowMore: true

    },
    {
      name: 'Current State',
      dataKey: 'currentState',
      position: 'left',
      type: 'text',
      isSortable: true,
      alwaysShowMore: true

    },
    {
      name: 'Modified Date',
      dataKey: 'modifiedDate',
      position: 'left',
      type: 'date',
      isSortable: true
    },
  ];
  

  export const QUESTION_TYPES = [
  { label: 'Multiple Choice Question', value: 'mcq' },
  { label: 'True/False Question', value: 'true_false' },
  { label: 'Fill in the Blanks Question', value: 'fill_blanks' },
  { label: 'Matching Question', value: 'matching' },
  { label: 'Subjective Answer Question', value: 'subjective' },
  { label: 'Scenario Based Question', value: 'scenario_based' },
  { label: 'Multi Select Question', value: 'multi_select' },
  { label: 'Activity Performance Task', value: 'activity_performance' },
  { label: 'Activity - Video Response', value: 'audio_video' },
  { label: 'Viva', value: 'live_viva' },
  { label: 'Activity - File Submission', value: 'file_submission' }
];

export const DIFFICULTY_LEVELS = [
  { label: 'Easy', value: 'easy' },
  { label: 'Medium', value: 'medium' },
  { label: 'Difficulty', value: 'hard' }
];

export const QUESTION_CATEGORIES = [
  { label: 'Practical', value: 'Practical' },
  { label: 'Theory', value: 'Theory' },
  { label: 'Viva', value: 'Viva' }
];

export const DATE = [
  { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' }
];
export const QUESTION_STATUS = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Archived', value: 'archived' },
  { label: 'Deleted', value: 'deleted' }
];

export const LANGUAGES = [
  { code: 'English', name: 'English' },
  { code: 'Hindi', name: 'Hindi' },
  { code: 'Tamil', name: 'Tamil' },
  { code: 'Telugu', name: 'Telugu' },
  { code: 'Kannada', name: 'Kannada' },
  { code: 'Gujarati', name: 'Gujarati' },
  { code: 'Oriya', name: 'Oriya' },
  { code: 'Assamese', name: 'Assamese' },
  { code: 'Urdu', name: 'Urdu' },
  { code: 'Marathi', name: 'Marathi' },
  { code: 'Malayalam', name: 'Malayalam' },
  { code: 'Bengali', name: 'Bengali' },
  { code: 'Punjabi', name: 'Punjabi' },
  { code: 'Manipuri', name: 'Manipuri' }
];